// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"4ae49cfb","37":"23ee0425","107":"18c9ee9d","122":"013870a4","367":"40769184","453":"d456ce70","545":"6aa0c84f","747":"fe5d56d5","836":"0d79ca31","862":"7f60d308","900":"203319da"}[chunkId] + ".chunk.js";
};